package com.swetdot.swetgram.protocol.dto

import com.swetdot.swetgram.protocol.Timestamp
import com.swetdot.swetgram.protocol.Uuid
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
enum class XpShopCategory {
    @SerialName("streak_saver") STREAK_SAVER,
    @SerialName("app_icon") APP_ICON,
    @SerialName("avatar_frame") AVATAR_FRAME,
    @SerialName("badge") BADGE,
    @SerialName("black_pass") BLACK_PASS,
    @SerialName("reaction_pack") REACTION_PACK,
    @SerialName("unknown") UNKNOWN,
}

@Serializable
data class XpShopItem(
    @SerialName("code") val code: String,
    @SerialName("category") val category: XpShopCategory = XpShopCategory.UNKNOWN,
    @SerialName("title") val title: String,
    @SerialName("description") val description: String,
    @SerialName("price_xp") val priceXp: Int,
    @SerialName("badge_icon") val badgeIcon: String? = null,
    @SerialName("enabled") val enabled: Boolean = true,
    @SerialName("is_owned") val isOwned: Boolean = false,
)

@Serializable
data class XpShopItemList(
    @SerialName("items") val items: List<XpShopItem>,
    @SerialName("spendable_xp") val spendableXp: Int,
    @SerialName("streak_freezes") val streakFreezes: Int,
)

@Serializable
data class PurchaseShopItemRequest(
    @SerialName("client_id") val clientId: Uuid,
    @SerialName("item_code") val itemCode: String,
)

@Serializable
data class PurchaseShopItemResponse(
    @SerialName("purchase_id") val purchaseId: Uuid,
    @SerialName("item_code") val itemCode: String,
    @SerialName("remaining_xp") val remainingXp: Int,
    @SerialName("streak_freezes") val streakFreezes: Int,
    @SerialName("purchased_at") val purchasedAt: Timestamp,
)
